import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _7kIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"7k"} ref={ref}/>
});

_7kIcon.displayName = "_7kIcon";
